import React, { useEffect } from 'react';
import Dropdown from 'sushiweb/Dropdown';
import MenuItem from 'sushiweb/MenuItem';

const getMenuItems = (items, itemSize) => {
  const dropdownItems = items && Object.keys(items);

  return (
    dropdownItems &&
    dropdownItems.map((item, index) => {
      return (
        <MenuItem
          key={index}
          value={`${item}`}
          label={items[item]}
          fontSize={itemSize}
          isMultiliner={true}
        />
      );
    })
  );
};

export const DropdownWrapper = ({
  isNaked = false,
  onSelect,
  dropdownVal,
  dropDownValues,
  itemSize = '14px',
  placeholder = '',
  groupedReason,
  groupedReasonId,
  maxMenuHeight = '40rem',
  rightIcon,
  staticHeader,
  notify = false,
  error = false,
  errorText = '',
}) => {
  let value = placeholder;
  let dropdownHeader = null;

  if (groupedReason) {
    value = groupedReasonId;
    dropdownHeader = groupedReason[groupedReasonId];
  } else if (dropdownVal && !groupedReason) {
    value = dropdownVal;
    dropdownHeader = dropDownValues[dropdownVal];
  } else {
    value = placeholder;
    dropdownHeader = placeholder;
  }

  if (!notify) {
    staticHeader = <div className='dropdownHeader'>{dropdownHeader}</div>;
  }

  useEffect(() => {
    const chidrenElements =
      document.getElementsByClassName('shushiweb-dropdown');

    if (!chidrenElements || !chidrenElements?.length) return;

    for (let i = 0; i < chidrenElements.length; i++) {
      let targetElement;

      if (
        chidrenElements[i].children?.length &&
        chidrenElements[i].children[0].children?.length
      )
        targetElement = chidrenElements[i].children[0].children[0];

      if (targetElement) targetElement.removeAttribute('tabIndex');
    }
  }, []);

  return (
    <div className='col shushiweb-dropdown' id='dropdown-wrapper'>
      <Dropdown
        value={value}
        width='100%'
        isNaked={isNaked}
        onSelect={onSelect}
        maxMenuHeight={maxMenuHeight}
        rightIcon={rightIcon}
        staticHeader={staticHeader}
      >
        {getMenuItems(dropDownValues, itemSize)}
      </Dropdown>
      {error && <p className='errorText'>{errorText}</p>}
    </div>
  );
};
